/**
 * Release gate for Complete → Reopen VQQ (14630).
 * false → UI hides Reopen actions; BE endpoint remains for future enablement.
 * true → sponsor/admin see Reopen on Complete VQQs when other gates pass.
 */
export const VQQ_REOPEN_ENABLED = false;

export function isVqqReopenFeatureEnabled() {
  return VQQ_REOPEN_ENABLED;
}
